import Swiper, { Scrollbar, A11y, Autoplay, Pagination, Navigation } from "swiper"

Swiper.use([Scrollbar, A11y, Autoplay, Pagination, Navigation])
// import Swiper styles
import "swiper/swiper-bundle.css"

const Carousel = el => {
  let swiper

  const createSwiper = () => {
    swiper = new Swiper(el, {
      direction: "horizontal",
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 0,
      speed: 300,
      keyboard: {
        enabled: true,
      },
      autoplay: {
        delay: 5000,
      },
      disableOnInteraction: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper__btn-next",
        prevEl: ".swiper__btn-prev",
      },
    })

    // Disable autoplay on hover
    swiper.el.addEventListener(
      "mouseenter",
      () => {
        swiper.autoplay.stop()
      },
      false
    )

    swiper.el.addEventListener(
      "mouseleave",
      () => {
        swiper.autoplay.start()
      },
      false
    )

    // Collection of themes used per slide
    let themes = []
    // On Slide change event
    swiper.on("slideChange", function() {
      // Current active slide
      let slideIndex = this.realIndex
      let currentSlide = this.slides[slideIndex]
      // If theme data attribute exists in the slide element then copy the class to navigation to allow for changing styles per slide
      if (currentSlide && currentSlide.getAttribute("data-theme")) {
        // Current slide theme
        let theme = currentSlide.getAttribute("data-theme")
        // Add slide theme to collection
        if (!themes.includes(theme)) {
          themes.push(theme)
        }

        // Remove all themes from the pagination element
        themes.forEach(theme => this.pagination.$el[0].classList.remove(theme))
        // Add the current theme to pagination element
        this.pagination.$el[0].classList.add(theme)
      }
    })
  }

  // Create swiper on load
  createSwiper()

  // Before print view disable swiper
  window.onbeforeprint = () => {
    swiper.destroy()
  }

  // After print view re-create swiper
  window.onafterprint = () => {
    createSwiper()
  }
}

export default () => {
  const carousels = document.querySelectorAll(".swiper-container")

  if (carousels.length) {
    carousels.forEach(el => Carousel(el))
  }
}
